// import React, { useState } from 'react';
// import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
// import { CircularProgress } from '@mui/material';
// import Swal from 'sweetalert2';

// const API_URL = process.env.REACT_APP_API;

// const DebitCreditNoteSummary = ({ fromDate, toDate, companyCode, yearCode, Tran_Type, accode }) => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState('');
//     const [isDataFetched, setIsDataFetched] = useState(false);

//     const AccountYear = sessionStorage.getItem("Accounting_Year");

//     let formattedYear = "";

//     if (AccountYear) {
//         const years = AccountYear.split(" - ");
//         if (years.length === 2) {
//             const startYear = years[0].slice(0, 4);
//             const endYear = years[1].slice(2, 4);
//             formattedYear = `${startYear}-${endYear}`;
//         }
//     }

//     const fetchDebitCreditNoteSummary = async () => {
//         try {
//             setLoading(true);
//             setError('');
//             const response = await axios.get(`${API_URL}/DebitCreditNote-summary`, {
//                 params: {
//                     from_date: fromDate,
//                     to_date: toDate,
//                     Company_Code: companyCode,
//                     Year_Code: yearCode,
//                     Tran_Type: Tran_Type,
//                     accode: accode
//                 },
//             });
//             if (response.data.length === 0) {
//                 Swal.fire({
//                     icon: 'error',
//                     title: 'Data Not Found.!',
//                     text: 'No DebitCredit Note data found for the selected date range.',
//                 });
//                 return;
//             }
//             setData(response.data);
//             setIsDataFetched(true);
//             openReportInNewTab(response.data, Tran_Type);
//         } catch (err) {
//             setError('Failed to fetch data');
//         } finally {
//             setLoading(false);
//         }
//     };

//    const openReportInNewTab = (data, Tran_Type) => {
//     const tranTypeNames = {
//         DN: "Debit Note to Customer",
//         CN: "Credit Note to Customer",
//         DS: "Debit Note to Supplier",
//         CS: "Credit Note to Supplier"
//     };
//     const tranTypeFullName = tranTypeNames[Tran_Type] || Tran_Type;

//     const newWindow = window.open('', '_blank');
//     if (!newWindow) {
//         alert("Pop-up blocked! Please allow pop-ups for this site to view the report.");
//         return;
//     }

//     const columns = [
//         'SRNO', 'Inovice_No', 'Invoice_Date', 'Bill To ACC NO', 'BilltoName',
//         'BILL TO GSTIN', 'BillToStateCode', 'PlaceOfSupply', 'TaxableAmt',
//         'CGST', 'SGST', 'IGST', 'TCS', 'Payable_Amount',
//         'OldInvNo', 'OldInvDate', 'ACKNo'
//     ];

//     // Assuming calculateTotals is defined elsewhere and works correctly
//     const totals = calculateTotals(data); // Make sure calculateTotals is accessible here

//     // Generate HTML for the table rows
//     const tableRows = data.map(row => `
//         <tr>
//             <td>${row.SRNO || ''}</td>
//             <td>${row.Inovice_No || ''}</td>
//             <td>${row.Invoice_Date || ''}</td>
//             <td>${row['Bill To ACC NO'] || ''}</td>
//             <td>${row.BilltoName || ''}</td>
//             <td>${row['BILL TO GSTIN'] || ''}</td>
//             <td>${row.BillToStateCode || ''}</td>
//             <td>${row.PlaceOfSupply || ''}</td>
//             <td>${(parseFloat(row.TaxableAmt) || 0).toFixed(2)}</td>
//             <td>${(parseFloat(row.CGST) || 0).toFixed(2)}</td>
//             <td>${(parseFloat(row.SGST) || 0).toFixed(2)}</td>
//             <td>${(parseFloat(row.IGST) || 0).toFixed(2)}</td>
//             <td>${(parseFloat(row.TCS) || 0).toFixed(2)}</td>
//             <td>${(parseFloat(row.Payable_Amount) || 0).toFixed(2)}</td>
//             <td>${row.OldInvNo || ''}</td>
//             <td>${row.OldInvDate || ''}</td>
//             <td>${row.ACKNo || ''}</td>
//         </tr>
//     `).join('');

//     const tableHeaders = columns.map(col => `<th>${col}</th>`).join('');

//     const baseFilename = Tran_Type === 'AL' ? "DebitCreditNoteSummary" : `${tranTypeFullName}`;

//     const exportXlsxScript = `
//         <script src="https://unpkg.com/xlsx/dist/xlsx.full.min.js"></script>
//         <script>
//             function exportToXlsx() {
//                 const data = ${JSON.stringify(data)};
//                 // tranTypeFullName and baseFilename are now passed in from the outer scope
//                 const fileName = "${baseFilename}.xlsx"; // Use the determined filename

//                 const columnOrder = ${JSON.stringify(columns)};
//                 const formattedData = data.map(row => ({
//                     ...row,
//                     TaxableAmt: parseFloat(row.TaxableAmt) || 0,
//                     CGST: parseFloat(row.CGST) || 0,
//                     SGST: parseFloat(row.SGST) || 0,
//                     IGST: parseFloat(row.IGST) || 0,
//                     TCS: parseFloat(row.TCS) || 0,
//                     Payable_Amount: parseFloat(row.Payable_Amount) || 0,
//                 }));
//                 const ws = XLSX.utils.json_to_sheet(formattedData, { header: columnOrder, skipHeader: false });
//                 const range = XLSX.utils.decode_range(ws['!ref']);
//                 for (let row = range.s.r + 1; row <= range.e.r; row++) {
//                     [8,9,10,11,12,13,14].forEach(col => {
//                         const cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
//                         if (cell) cell.z = '0.00';
//                     });
//                 }
//                 const wb = XLSX.utils.book_new();
//                 XLSX.utils.book_append_sheet(wb, ws, "SaleTCSData");
//                 const xlsx = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
//                 const blob = new Blob([xlsx], { type: "application/octet-stream" });
//                 const link = document.createElement("a");
//                 link.href = URL.createObjectURL(blob);
//                 link.setAttribute("download", fileName); 
//                 document.body.appendChild(link);
//                 link.click();
//                 document.body.removeChild(link);
//             }
//         </script>
//     `;
//         newWindow.document.write(`
//             <html>
//                 <head>
//                     <title>Debit Credit Note Summary</title>
//                     <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
//                       <script>${exportXlsxScript}</script>
//                                         <style>
//                     body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
//                     h2 { text-align: center; margin-top: 0; }
//                     .table-container {
//                         max-height: 500px;
//                         overflow-y: auto;
//                         margin: 20px auto;
//                         width: 90%;
//                     }
//                     table {
//                         width: 100%;
//                         border-collapse: collapse;
//                     }
//                     th, td {
//                         border: 1px solid #ddd;
//                         padding: 6px 8px;
//                         text-align: left;
//                         white-space: nowrap;
//                     }
//                     th {
//                         background-color:rgb(206, 200, 243);
//                         position: sticky;
//                         top: 0;
//                         z-index: 2;
//                         font-weight: bold;
//                         font-size: 20px;
//                         height: 50px;
//                         text-align: center;
//                     }
//                     .export-btn {
//                         padding: 10px 20px;
//                         font-size: 16px;
//                         background-color: green;
//                         color: white;
//                         border: none;
//                         cursor: pointer;
//                         margin-bottom: 20px;
//                         margin-top: 20px;
//                     }
//                     .total-row {
//                         background-color: yellow;
//                         font-weight: bold;
//                     }
//                 </style>
//                 </head>
//                 <body>
//                     <h2>Debit Credit Note Summary Report</h2>
//                     <button class="export-btn" onclick="window.exportToXlsx()">Export to XLSX</button>
//                     <table>
//                         <thead>
//                             <tr>
//                                 ${columns.map((column) => `<th>${column}</th>`).join('')}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             ${data.map(row => {
//             return `
//                                     <tr>
//                                     ${columns.map(column => {
//                 if (['TaxableAmt', 'CGST', 'SGST', 'IGST', 'Payable_Amount'].includes(column)) {
//                     return `<td style="text-align: right;">${formatReadableAmount(row[column] || 0)}</td>`;
//                 } else {
//                     return `<td>${row[column] || ''}</td>`;
//                 }
//             }).join('')}
//                                     </tr>
//                                 `;
//         }).join('')}
//                         </tbody>
//                         <tfoot>
//                             <tr class="total-row">
//                               <td style={{ fontWeight: 'bold', backgroundColor: 'yellow' }} colSpan="7"></td>
//                                 <td>Total</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.TaxableAmt.toFixed(2))}</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.CGST.toFixed(2))}</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.SGST.toFixed(2))}</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.IGST.toFixed(2))}</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.TCS.toFixed(2))}</td>
//                                 <td style="text-align: right;">${formatReadableAmount(totals.Payable_Amount.toFixed(2))}</td>
//                             </tr>
//                         </tfoot>
//                     </table>
//                 </body>
//             </html>
//         `);

//         newWindow.document.close();
//     };

//     const calculateTotals = (data) => {
//         let totals = {
//             TaxableAmt: 0,
//             CGST: 0,
//             SGST: 0,
//             IGST: 0,
//             TCS: 0,
//             Payable_Amount: 0,
//         };

//         data.forEach(row => {
//             totals.TaxableAmt += parseFloat(row.TaxableAmt || 0);
//             totals.CGST += parseFloat(row.CGST || 0);
//             totals.SGST += parseFloat(row.SGST || 0);
//             totals.IGST += parseFloat(row.IGST || 0);
//             totals.TCS += parseFloat(row.TCS || 0);
//             totals.Payable_Amount += parseFloat(row.Payable_Amount || 0);
//         });
//         return totals;
//     };

//     return (
//         <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
//             <button
//                 variant="contained"
//                 color="primary"
//                 onClick={fetchDebitCreditNoteSummary}
//                 disabled={loading}
//                 style={{
//                     width: '20%',
//                     height: '60px',
//                 }}
//             >
//                 {loading ? <CircularProgress size={24} /> : 'Debit Credit Note Summary'}
//             </button>

//             {error && <div className="alert alert-danger">{error}</div>}
//         </div>
//     );
// };

// export default DebitCreditNoteSummary;




import React, { useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { formatReadableAmount } from "../../Common/FormatFunctions/FormatAmount"
import { CircularProgress } from '@mui/material';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API;

const DebitCreditNoteSummary = ({ fromDate, toDate, companyCode, yearCode, Tran_Type, accode }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [isDataFetched, setIsDataFetched] = useState(false);

    const AccountYear = sessionStorage.getItem("Accounting_Year");

    let formattedYear = "";

    if (AccountYear) {
        const years = AccountYear.split(" - ");
        if (years.length === 2) {
            const startYear = years[0].slice(0, 4);
            const endYear = years[1].slice(2, 4);
            formattedYear = `${startYear}-${endYear}`;
        }
    }

    const fetchDebitCreditNoteSummary = async () => {
        try {
            setLoading(true);
            setError('');
            const response = await axios.get(`${API_URL}/DebitCreditNote-summary`, {
                params: {
                    from_date: fromDate,
                    to_date: toDate,
                    Company_Code: companyCode,
                    Year_Code: yearCode,
                    Tran_Type: Tran_Type,
                    accode: accode
                },
            });
            if (response.data.length === 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Data Not Found.!',
                    text: 'No DebitCredit Note data found for the selected date range.',
                });
                return;
            }
            setData(response.data);
            setIsDataFetched(true);
            openReportInNewTab(response.data, Tran_Type);
        } catch (err) {
            setError('Failed to fetch data');
        } finally {
            setLoading(false);
        }
    };

    const calculateTotals = (data) => {
        let totals = {
            TaxableAmt: 0,
            CGST: 0,
            SGST: 0,
            IGST: 0,
            TCS: 0,
            Payable_Amount: 0,
        };

        data.forEach(row => {
            totals.TaxableAmt += parseFloat(row.TaxableAmt || 0);
            totals.CGST += parseFloat(row.CGST || 0);
            totals.SGST += parseFloat(row.SGST || 0);
            totals.IGST += parseFloat(row.IGST || 0);
            totals.TCS += parseFloat(row.TCS || 0);
            totals.Payable_Amount += parseFloat(row.Payable_Amount || 0);
        });
        return totals;
    };

    const openReportInNewTab = (data, Tran_Type) => {
        const tranTypeNames = {
            DN: "Debit Note to Customer",
            CN: "Credit Note to Customer",
            DS: "Debit Note to Supplier",
            CS: "Credit Note to Supplier"
        };
        const tranTypeFullName = tranTypeNames[Tran_Type] || Tran_Type;

        const newWindow = window.open('', '_blank');
        if (!newWindow) {
            alert("Pop-up blocked! Please allow pop-ups for this site to view the report.");
            return;
        }

        const columns = [
            'SRNO', 'Inovice_No', 'Invoice_Date', 'Bill To ACC NO', 'BilltoName',
            'BILL TO GSTIN', 'BillToStateCode', 'PlaceOfSupply', 'TaxableAmt',
            'CGST', 'SGST', 'IGST', 'TCS', 'Payable_Amount',
            'OldInvNo', 'OldInvDate', 'ACKNo'
        ];

        const totals = calculateTotals(data); // Calculate totals here

        const tableRows = data.map(row => `
            <tr>
                <td>${row.SRNO || ''}</td>
                <td>${row.Inovice_No || ''}</td>
                <td>${row.Invoice_Date || ''}</td>
                <td>${row['Bill To ACC NO'] || ''}</td>
                <td>${row.BilltoName || ''}</td>
                <td>${row['BILL TO GSTIN'] || ''}</td>
                <td>${row.BillToStateCode || ''}</td>
                <td>${row.PlaceOfSupply || ''}</td>
                <td>${(parseFloat(row.TaxableAmt) || 0).toFixed(2)}</td>
                <td>${(parseFloat(row.CGST) || 0).toFixed(2)}</td>
                <td>${(parseFloat(row.SGST) || 0).toFixed(2)}</td>
                <td>${(parseFloat(row.IGST) || 0).toFixed(2)}</td>
                <td>${(parseFloat(row.TCS) || 0).toFixed(2)}</td>
                <td>${(parseFloat(row.Payable_Amount) || 0).toFixed(2)}</td>
                <td>${row.OldInvNo || ''}</td>
                <td>${row.OldInvDate || ''}</td>
                <td>${row.ACKNo || ''}</td>
            </tr>
        `).join('');

        const tableHeaders = columns.map(col => `<th>${col}</th>`).join('');

        const baseFilename = Tran_Type === 'AL' ? "DebitCreditNoteSummary" : `${tranTypeFullName}`;

        const exportXlsxScript = `
            <script src="https://unpkg.com/xlsx/dist/xlsx.full.min.js"></script>
            <script>
                function exportToXlsx() {
                    const data = ${JSON.stringify(data)};
                    const totals = ${JSON.stringify(totals)}; // Pass totals to the script
                    const fileName = "${baseFilename}.xlsx";

                    const columnOrder = ${JSON.stringify(columns)};
                    const formattedData = data.map(row => ({
                        ...row,
                        TaxableAmt: parseFloat(row.TaxableAmt) || 0,
                        CGST: parseFloat(row.CGST) || 0,
                        SGST: parseFloat(row.SGST) || 0,
                        IGST: parseFloat(row.IGST) || 0,
                        TCS: parseFloat(row.TCS) || 0,
                        Payable_Amount: parseFloat(row.Payable_Amount) || 0,
                    }));

                    const ws = XLSX.utils.json_to_sheet(formattedData, { header: columnOrder, skipHeader: false });
                    
                    // Append the totals row
                    const totalsRow = {
                        'SRNO': '', // Empty for SRNO
                        'Inovice_No': '',
                        'Invoice_Date': '',
                        'Bill To ACC NO': '',
                        'BilltoName': '',
                        'BILL TO GSTIN': '',
                        'BillToStateCode': 'Total', // Label for totals row
                        'PlaceOfSupply': '',
                        'TaxableAmt': totals.TaxableAmt,
                        'CGST': totals.CGST,
                        'SGST': totals.SGST,
                        'IGST': totals.IGST,
                        'TCS': totals.TCS,
                        'Payable_Amount': totals.Payable_Amount,
                        'OldInvNo': '',
                        'OldInvDate': '',
                        'ACKNo': ''
                    };
                    XLSX.utils.sheet_add_json(ws, [totalsRow], { skipHeader: true, origin: -1 }); // -1 appends to the end

                    const range = XLSX.utils.decode_range(ws['!ref']);
                    for (let row = range.s.r + 1; row <= range.e.r; row++) {
                        [8,9,10,11,12,13].forEach(col => { // Adjust column indices for amounts
                            const cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
                            if (cell) cell.z = '0.00';
                        });
                    }

                    // Apply number format to totals row as well
                    const lastRow = range.e.r + 1; // Index of the newly added totals row
                    [8,9,10,11,12,13].forEach(col => {
                        const cell = ws[XLSX.utils.encode_cell({ r: lastRow, c: col })];
                        if (cell) cell.z = '0.00';
                    });

                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "DebitCreditNoteData"); // Changed sheet name for clarity
                    const xlsx = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                    const blob = new Blob([xlsx], { type: "application/octet-stream" });
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute("download", fileName); 
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            </script>
        `;
        newWindow.document.write(`
            <html>
                <head>
                    <title>Debit Credit Note Summary</title>
                    <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js"></script>
                    <script>${exportXlsxScript}</script>
                    <style>
                        body { font-family: Arial, sans-serif; padding: 20px; text-align: center; }
                        h2 { text-align: center; margin-top: 0; }
                        .table-container {
                            max-height: 500px;
                            overflow-y: auto;
                            margin: 20px auto;
                            width: 90%;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 6px 8px;
                            text-align: left;
                            white-space: nowrap;
                        }
                        th {
                            background-color:rgb(206, 200, 243);
                            position: sticky;
                            top: 0;
                            z-index: 2;
                            font-weight: bold;
                            font-size: 20px;
                            height: 50px;
                            text-align: center;
                        }
                        .export-btn {
                            padding: 10px 20px;
                            font-size: 16px;
                            background-color: green;
                            color: white;
                            border: none;
                            cursor: pointer;
                            margin-bottom: 20px;
                            margin-top: 20px;
                        }
                        .total-row {
                            background-color: yellow;
                            font-weight: bold;
                        }
                    </style>
                </head>
                <body>
                    <h2>Debit Credit Note Summary Report</h2>
                    <button class="export-btn" onclick="window.exportToXlsx()">Export to XLSX</button>
                    <table>
                        <thead>
                            <tr>
                                ${columns.map((column) => `<th>${column}</th>`).join('')}
                            </tr>
                        </thead>
                        <tbody>
                            ${data.map(row => {
                                return `
                                    <tr>
                                    ${columns.map(column => {
                                        if (['TaxableAmt', 'CGST', 'SGST', 'IGST', 'TCS', 'Payable_Amount'].includes(column)) { 
                                            return `<td style="text-align: right;">${formatReadableAmount(row[column] || 0)}</td>`;
                                        } else {
                                            return `<td>${row[column] || ''}</td>`;
                                        }
                                    }).join('')}
                                    </tr>
                                `;
                            }).join('')}
                        </tbody>
                        <tfoot>
                            <tr class="total-row">
                                <td style="font-weight: bold; background-color: yellow;" colSpan="7"></td>
                                <td>Total</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.TaxableAmt.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.CGST.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.SGST.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.IGST.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.TCS.toFixed(2))}</td>
                                <td style="text-align: right;">${formatReadableAmount(totals.Payable_Amount.toFixed(2))}</td>
                                <td colSpan="2"></td>
                            </tr>
                        </tfoot>
                    </table>
                </body>
            </html>
        `);

        newWindow.document.close();
    };

    return (
        <div className="d-flex flex-column align-items-center" style={{ marginTop: '5px' }}>
            <button
                variant="contained"
                color="primary"
                onClick={fetchDebitCreditNoteSummary}
                disabled={loading}
                style={{
                    width: '20%',
                    height: '60px',
                }}
            >
                {loading ? <CircularProgress size={24} /> : 'Debit Credit Note Summary'}
            </button>

            {error && <div className="alert alert-danger">{error}</div>}
        </div>
    );
};

export default DebitCreditNoteSummary;
